module.exports = __webpack_public_path__ + "img/about.86259cb8.jpg";